export let plurals = {
  aggregated_somatic_mutation: 'Aggregated Somatic Mutations',
  aligned_reads: 'Aligned Reads',
  aliquot: 'Aliquots',
  analysis_metadata: 'Analysis Metadata',
  analyte: 'Analytes',
  annotated_somatic_mutation: 'Annotated Somatic Mutations',
  annotation: 'Annotations',
  biospecimen_data_bundle: 'Biospecimen Data Bundles',
  biospecimen_supplement: 'Biospecimen Supplements',
  case: 'Cases',
  clinical_data_bundle: 'Clinical Data Bundles',
  clinical_supplement: 'Clinical Supplements',
  clinical_test: 'Clinical Tests',
  demographic: 'Demographics',
  diagnosis: 'Diagnoses',
  experiment_metadata: 'Experiment Metadata',
  exposure: 'Exposures',
  family_history: 'Family Histories',
  gene_expression: 'Gene Expressions',
  mirna_expression: 'MiRNA Expressions',
  pathology_data_bundle: 'Pathology Data Bundles',
  pathology_report: 'Pathology Reports',
  portion: 'Portions',
  read_group: 'Read Groups',
  run_metadata: 'Run Metadata',
  sample: 'Samples',
  slide: 'Slides',
  slide_image: 'Slide Images',
  submitted_aligned_reads: 'Submitted Aligned Reads',
  submitted_file: 'Submitted Files',
  submitted_genomic_profile: 'Submitted Genomic Profiles',
  submitted_tangent_copy_number: 'Submitted Tangent Copy Numbers',
  submitted_unaligned_reads: 'Submitted Unaligned Reads',
  treatment: 'Treatments',
  transaction: 'Transactions',
  simple_somatic_mutation: 'Simple Somatic Mutations',
};

export let pluralize = term => plurals[term] || term;
